import { render, staticRenderFns } from "./SSelect.vue?vue&type=template&id=42a34518&scoped=true&"
import script from "./SSelect.vue?vue&type=script&lang=js&"
export * from "./SSelect.vue?vue&type=script&lang=js&"
import style0 from "./SSelect.vue?vue&type=style&index=0&id=42a34518&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a34518",
  null
  
)

export default component.exports